import styled, { css } from 'styled-components';

import { ButtonContainer } from 'libs/ui';

export const StyledButtonContainer = styled(ButtonContainer)`
  margin-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const StyledInput = styled.input`
  height: 36px;
  padding: 5px;
  ${(props) =>
    props.theme.ui === 'v2' &&
    css`
      flex: 1;
      max-width: 240px;
      padding: 0 12px;
      border: 1px solid var(--cp-border);
      border-radius: 10px;
      background: var(--cp-surface);
      color: var(--cp-text);
      font-size: 14px;
      outline: none;
      transition: border-color 0.15s ease, box-shadow 0.15s ease;
      &::placeholder {
        color: var(--cp-text-tertiary);
      }
      &:focus {
        border-color: var(--cp-green);
        box-shadow: 0 0 0 3px rgba(71, 185, 114, 0.15);
      }
    `}
`;

export const Content = styled.div`
  height: 500px;
  overflow-y: auto;
`;
export const Permissions = styled.div`
  /* display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  flex-grow: 0;
  flex-wrap: wrap;
  > * {
    width: 100%;
    font-size: 16px;
  } */
  input {
    cursor: pointer;
    margin: 0 0.5rem 0 0;
  }
  label {
    cursor: pointer;
    display: flex;
    font-weight: normal;
    align-items: center;
    margin: 0 0 5px;
    flex-grow: 0;
    input {
      width: 20px;
      height: 20px;
    }
  }
`;
